export default __webpack_public_path__ + "static/media/4.72980680.webp";